export default __webpack_public_path__ + "static/media/install.e056388f.png";